import smartSolveApi from './instances/smartsolve';
import { waitForCachedData } from '../utils/cacheUtils';

export const TRAINING_MANAGEMENT = 'TrainingManagement';
export const DOCUMENT_AND_TRAINING_MANAGEMENT = 'DocumentAndTrainingManagement';

const modulesCache = {};
const onGoingCalls = {};

export const moduleIsInstalled = async (moduleName) => {
  try {
    if (onGoingCalls[moduleName]) {
      // wait for data
      const cachedData = await waitForCachedData(modulesCache, moduleName, 50);
      return cachedData;
    } else {
      onGoingCalls[moduleName] = true;
    }

    const response = await smartSolveApi.post('/moduleisinstalled', {
      moduleName,
    });

    modulesCache[moduleName] = response.data;
    delete onGoingCalls[moduleName];

    return response.data;
  } catch (e) {
    throw new Error(`moduleIsInstalled() failed: ${e}`);
  }
};
